import { createApp } from 'vue'
import { usePricingMode, type PricingModeOpt } from './composables/usePricingMode'
import './style.css'
import App from './App.vue'
import { useSiteFeatures, type SiteFeatures } from './composables/useSiteFeatures'

export interface OnwardSearcherConfig {
  pricing?: PricingModeOpt
  features?: SiteFeatures
}
class OnwardSearcher {
  mount(id: string|Element, config?: OnwardSearcherConfig) {
    const app = createApp(App)

    usePricingMode.provide(config?.pricing ?? {}, app)
    useSiteFeatures.provide(config?.features ?? {}, app)

    app.mount(id)
  }
}

if (window) {
  window.OnwardSearcher = OnwardSearcher
}

declare global {
  interface Window {
    OnwardSearcher: typeof OnwardSearcher
  }
}

export default OnwardSearcher